import { render } from "./PriceBadge.vue?vue&type=template&id=c895fcec"
import script from "./PriceBadge.vue?vue&type=script&lang=js"
export * from "./PriceBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__